import { render } from "./PackagesFaqPage.vue?vue&type=template&id=20e4f4b5"
import script from "./PackagesFaqPage.vue?vue&type=script&lang=js"
export * from "./PackagesFaqPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__